import { isHuawei } from 'util/device';

/**
 * @class
 * A representation of an on Footer Navigation objcet.
 *
 * @param {object} footerNav - Footer Navigation object.
 */
export default class FooterNavigation {
  constructor(footerNav) {
    const primary = [];
    const secondary = [];

    if (footerNav.primary) {
      footerNav.primary.navigationItems.forEach((entry) => {
        if (entry.fields.pageLink && entry.fields.pageLink.fields.slug === 'juke-app' && isHuawei) {
          return;
        }
        primary.push({
          title: entry.fields.title,
          pageLink: entry.fields.pageLink ? { slug: entry.fields.pageLink.fields.slug } : null,
          pageUrl: entry.fields.pageUrl ? entry.fields.pageUrl : null,
        });
      });
    }

    if (footerNav.secondary) {
      footerNav.secondary.navigationItems.forEach((entry) => {
        secondary.push({
          title: entry.fields.title,
          pageLink: entry.fields.pageLink ? { slug: entry.fields.pageLink.fields.slug } : null,
          pageUrl: entry.fields.pageUrl ? entry.fields.pageUrl : null,
        });
      });
    }

    return {
      primary,
      secondary,
    };
  }
}
